export default "__VITE_ASSET__e913c669__"